const userNeutralSinceYear = (userInfo) => userInfo?.neutral_since_year

const calcYear = (info) => info?.year || info?.calculation_year || new Date().getFullYear()

const dataYear = (info) => ((info?.year || info?.calculation_year || new Date().getFullYear()) - 1)

const replaceYearDynamic = (text, info) => text?.replaceAll('2022', dataYear(info))

export {userNeutralSinceYear, calcYear, dataYear, replaceYearDynamic}